<div class="container-cookies" *ngIf="showCookies" role="dialog" aria-labelledby="cookiesTitle" aria-describedby="cookiesDescription">
    <div class="container-cookies__content">
        <p id="cookiesDescription" class="container-cookies__content__text" i18n>
            Utilizamos cookies de terceros para mejorar nuestros servicios mediante el análisis de sus hábitos de navegación. Si continúa navegando, consideramos que acepta su uso. Puede cambiar la configuración u obtener más información en nuestra <a routerLink="/cookies">Política de Cookies</a>.
        </p>
        <button class="btn btn-primary" (click)="acceptCookies()">Aceptar</button>
    </div>
</div>